// extracted by mini-css-extract-plugin
export default {"orderGrid":"orderGrid_orderGrid__rGGB5"};